import { Badge, MantineColor } from "@mantine/core";
import { makeColorMap } from "src/utils/badges";

type ValueOf<T> = T[keyof T];

export function makeEnumBadgeComponent<E extends Record<string, string>>(
    e: E,
    type: 'filled' | 'outline' = 'filled',
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'lg',
    palette?: Record<string, MantineColor>,
) {
    const map = makeColorMap(e, palette);
    const allowed = new Set(Object.values(e) as string[]);

    return function EnumBadge({        
        status,
    }: {
        status: { value: string; display: string; relation_field?: string | null };
    }) {
        const v = allowed.has(status.value) ? (status.value as ValueOf<E>) : undefined;
        const color = v ? map[v] : 'gray';

        if (type === "outline") {
            return <Badge
                color={color}
                radius="sm"
                size={size}
                variant="outline"
                autoContrast
                styles={{
                    root: { backgroundColor: 'transparent' },
                    label: { color: color }
                }}
            >
                {status.display}
            </Badge>;
        }

        return <Badge
            color={color}
            radius="sm"
            size={size}
            autoContrast
        >
            {status.display}
        </Badge>;

    };
}